import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  cpHeaders,
  groupsTopHeaders,
  sgHeaders,
  tgHeaders,
} from '../../utils/balance-accounts';
import HeadquerterAccountsRows from './HeadquerterAccountsRows';
import TeamAccountsRows from './TeamAccountsRows';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const TeamAccountsTable = ({ data, tableRef }) => {
  const classes = useStyles();
  const [tableWidth, setTableWidth] = useState(420);
  const [emptyColSpan, setEmptyColSpan] = useState(12);

  // useEffect(() => {
  //     if (headerRows.length > 0) {
  //         const rowsWidth = (headerRows.length * 320) + 420;
  //         const colSpan = (headerRows.length * 4) + 2;
  //         //console.log(colSpan, 'colSpan')
  //         setTableWidth(rowsWidth);
  //         setEmptyColSpan(colSpan);
  //     }
  // }, [headerRows])

  if (!data) {
    return null;
  }

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              {groupsTopHeaders.map((header) => (
                <TableCell
                  colSpan={header?.colSpan ? header?.colSpan : 1}
                  rowSpan={header?.rowSpan ? header?.rowSpan : 1}
                  align="center"
                  key={header.val}
                >
                  {header.name}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {groupsTopHeaders.map((header) => {
                let subHeader = null;
                if (header.id === 'SG') {
                  subHeader = sgHeaders;
                } else if (header.id === 'TG') {
                  subHeader = tgHeaders;
                } else if (header.id === 'CP') {
                  subHeader = cpHeaders;
                }
                return (
                  subHeader &&
                  subHeader.map((sub, index) => (
                    <TableCell align="center" key={index}>
                      {sub.name}
                    </TableCell>
                  ))
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(data) && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <TeamAccountsRows headerRows={groupsTopHeaders} data={data} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TeamAccountsTable;
